import { Heart, MoonStar, PawPrint, ShieldCheck, Sparkles, Star } from "lucide-react";
import heroPets from "@/assets/hero-pets.webp";
import { LunaStoryModal } from "./LunaStoryModal";
import petmoonLogo from "@/assets/petmoon-logo.png.asset.json";

export function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* Decorative twinkling stars */}
      <Star
        aria-hidden
        fill="currentColor"
        className="absolute left-[6%] top-28 h-5 w-5 animate-twinkle text-accent/50"
      />
      <Star
        aria-hidden
        fill="currentColor"
        className="absolute right-[10%] top-40 h-4 w-4 animate-twinkle text-accent/40 [animation-delay:1.2s]"
      />
      <Star
        aria-hidden
        fill="currentColor"
        className="absolute left-[42%] top-20 hidden h-3.5 w-3.5 animate-twinkle text-accent/40 [animation-delay:2.1s] lg:block"
      />

      <div className="mx-auto grid max-w-6xl items-center gap-14 px-5 pb-20 pt-28 sm:pt-32 lg:grid-cols-2 lg:gap-10 lg:pb-28">
        <div className="text-center lg:text-left">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent/40 bg-gold-soft px-3 py-1.5 text-[10px] font-bold uppercase tracking-wider text-gold-deep sm:px-4 sm:text-xs sm:tracking-widest">
            <MoonStar className="h-3.5 w-3.5" aria-hidden />
            Zapopan y Guadalajara, Jalisco
          </span>

          <h1 className="mt-6 font-display text-4xl font-bold leading-[1.08] tracking-tight text-primary sm:text-5xl lg:text-[3.4rem]">
            PetMoon: Transporte <span className="text-gold-deep">Seguro</span> y{" "}
            <span className="text-gold-deep">Amoroso</span>
          </h1>

          <p className="mx-auto mt-5 max-w-md text-lg leading-relaxed text-muted-foreground lg:mx-0">
            El viaje que tu mascota merece, inspirado en el amor por Luna. Servicio en
            Zapopan, Guadalajara y zona metropolitana.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4 lg:justify-start">
            <a
              href="#reservar"
              className="group inline-flex items-center gap-2.5 rounded-full bg-accent px-8 py-4 text-base font-extrabold text-accent-foreground shadow-card transition-all hover:-translate-y-0.5 hover:shadow-glow"
            >
              <PawPrint
                className="h-5 w-5 transition-transform group-hover:rotate-12"
                aria-hidden
              />
              Solicitar Viaje
            </a>
            <LunaStoryModal className="text-primary hover:text-gold-deep" />
          </div>

          <ul className="mt-9 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-bold text-muted-foreground lg:justify-start">
            <li className="flex items-center gap-1.5">
              <ShieldCheck className="h-4 w-4 text-gold-deep" aria-hidden />
              Arneses 
            </li>
            <li className="flex items-center gap-1.5">
              <Sparkles className="h-4 w-4 text-gold-deep" aria-hidden />
              Unidad sanitizada
            </li>
            <li className="flex items-center gap-1.5">
              <Heart className="h-4 w-4 text-gold-deep" aria-hidden />
              Trato con amor
            </li>
          </ul>
        </div>

        <div className="relative mx-auto w-full max-w-xl lg:max-w-none">
          <div className="relative overflow-hidden rounded-[2.5rem] shadow-card ring-1 ring-border">
            <img
              src={heroPets}
              alt="Perro y gato viajando seguros con arnés en el asiento trasero, mirando la luna creciente por la ventana"
              width={1216}
              height={960}
              loading="eager"
              fetchPriority="high"
              decoding="async"
              className="h-full w-full object-cover"
            />
            <img
              src={petmoonLogo.url}
              alt="Logo de PetMoon"
              width={96}
              height={96}
              loading="eager"
              decoding="async"
              className="absolute right-4 top-4 h-16 w-16 animate-float rounded-full shadow-glow ring-2 ring-accent/70 sm:h-20 sm:w-20 [animation-delay:0.8s]"
            />

          </div>

          <div className="absolute -bottom-6 left-4 flex animate-float items-center gap-3 rounded-2xl bg-card px-4 py-3 shadow-soft ring-1 ring-border sm:left-6">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent">
              <MoonStar className="h-5 w-5 text-accent-foreground" aria-hidden />
            </span>
            <div>
              <p className="text-sm font-extrabold text-foreground">Viajes guiados por Luna</p>
              <p className="text-xs font-semibold text-muted-foreground">
                Cuidado premium, siempre
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
